// extracted by mini-css-extract-plugin
export var searchHeader = "_8l-0";
export var searchHeaderDark = "_8l-1";